/****************************************
  DevelatioVueSentry
  vue-sentry.js
  (C) Develatio Technologies S.L. 2019
*****************************************

Wraper for @sentry/browser
****************************************/
import * as Sentry from "@sentry/browser";

const DevelatioVueSentry = {
  // eslint-disable-next-line
  install(Vue, options) {
    Vue.mixin({
      methods: {
        $sentry(conf) {
          if (!conf.capture) {
            throw new TypeError(
              "Expected capture option in $sentry({}). Example: $sentry({capture: err})"
            );
          }

          if (conf.debug || process.env.NODE_ENV === "development") {
            // eslint-disable-next-line
            console.error(conf.capture);
          }

          // si el error se ha producido porque una petición ha sido abortada,
          // ha sido una acción del usuario desde el navegador (que le ha dado
          // a la X), asi que no lo registramos
          if (conf.capture.code == "ECONNABORTED" && conf.capture.toJSON) {
            if (conf.capture.toJSON().message == "Request aborted") {
              return;
            }
          }

          return Sentry.captureException(conf.capture);
        },
      },
    });
  },
};

export default DevelatioVueSentry;
